import { Head } from '@inertiajs/react';
import type { JudgesStagesShow } from '@/types';
import { Ballot } from '../components/Ballot';
import { PlatanusLogo } from '../components/PlatanusLogo';

// /judges/stages/:stage_slug — one stage's ballot (Judges::StagesController).
export default function Show({
  title,
  eventName,
  judgeName,
  ballot,
}: JudgesStagesShow) {
  return (
    <>
      <Head title={title} />
      <div className="theme-ph26 selection-on-light min-h-screen bg-background font-mono text-foreground">
        <Ballot ballot={ballot} judgeName={judgeName} eventName={eventName} />
        <div className="pb-12">
          <PlatanusLogo />
        </div>
      </div>
    </>
  );
}
